import toast from "react-hot-toast";

const { clientAPI } = require("../client");
export const relativeFormRequestCall = {
  approve: async (id, data) => {
    try {
      const response = await clientAPI(
        "put",
        `/relativeRegisterForm/approve/${id}`,
        data
      );
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  randomWeekdayTime: async () => {
    try {
      const response = await clientAPI(
        "get",
        `/relativeRegisterForm/app/randomWeekdayTime`
      );
      return response;
    } catch (error) {
      console.error("update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
};
